import React from 'react';
import NinjaOneLogoSvg from '@images/logos/ninja-one-logo.svg';
import PropTypes from 'prop-types';

export default function QboLogo({ logo }) {
  return (
    <div className="QboLogo__wrapper">
      <img
        src={logo || NinjaOneLogoSvg}
        alt="ninja-one-logo"
        className="Img__fluid QboLogo__main"
      />
    </div>
  );
}

QboLogo.propTypes = {
  logo: PropTypes.string,
};
QboLogo.defaultProps = {
  logo: null,
};
